import api from './api';

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

function shouldRetryConfirm(error) {
  const status = error?.response?.status;
  if (status === 404 || status >= 500) return true;
  // Receipt / RPC lag can briefly 400; retry a few times.
  if (status === 400) {
    const msg = String(error?.response?.data?.message || error?.message || '').toLowerCase();
    return (
      msg.includes('not found') ||
      msg.includes('not sent') ||
      msg.includes('does not contain') ||
      msg.includes('wait for confirmation')
    );
  }
  return false;
}

/**
 * Confirm jackpot claim with retries (RPC may lag before receipt is available).
 */
export async function confirmJackpotClaim({ predictionId, txHash, walletAddress, maxAttempts = 6 }) {
  let lastError;
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    try {
      const { data } = await api.post(`/jackpots/claim/${predictionId}/confirm`, {
        txHash,
        walletAddress,
      });
      return data;
    } catch (e) {
      lastError = e;
      if (shouldRetryConfirm(e) && attempt < maxAttempts - 1) {
        await sleep(1500 * (attempt + 1));
        continue;
      }
      throw e;
    }
  }
  throw lastError;
}

/**
 * Confirm boost/market claim with retries.
 */
export async function confirmPredictionClaim({ predictionId, txHash, walletAddress, maxAttempts = 6 }) {
  let lastError;
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    try {
      const { data } = await api.post(`/predictions/${predictionId}/claim`, {
        txHash,
        walletAddress,
      });
      return data;
    } catch (e) {
      lastError = e;
      if (shouldRetryConfirm(e) && attempt < maxAttempts - 1) {
        await sleep(1500 * (attempt + 1));
        continue;
      }
      // On final failure after a successful wallet tx, sync claimed state from chain.
      try {
        const { data: sync } = await api.post(`/predictions/${predictionId}/claim-sync`, {
          walletAddress,
          txHash,
        });
        if (sync?.claimed || sync?.synced) {
          return { prediction: sync.prediction, message: 'Claim synced from chain', synced: true };
        }
      } catch {
        /* ignore */
      }
      throw e;
    }
  }
  throw lastError;
}
